// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import fetchAndSetProjectCompanies from './fetchAndSetProjectCompanies'
import { postSplitProject } from 'helpers/api'
import { loadingToggler } from 'redux/modules/loading'

import {
  preventFormSubmission,
  throwSubmissionError,
} from 'helpers/reduxFormFunctions'

import {
  projectSummaryModalOpen,
  removeMultiplePaths,
  updateModalMessage,
} from 'redux/modules/projectSummary'

const splitProject = ({ projectName }, d, formProps) => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      // adds layer of validation for submit
      if (preventFormSubmission(formProps)) {
        return
      }

      const { projectSummary } = getState()
      const defaultCompanyId = projectSummary.getIn(['defaultCompany', 'defaultCompanyId']) || null
      const defaultContactId = projectSummary.getIn(['defaultContact', 'defaultContactId']) || null
      const paths = projectSummary.get('modalPathsSet').toJS()
      const projectTypeId = projectSummary.getIn(['projectType', 'projectTypeId']) || null

      const newProject = {
        defaultCompanyId,
        defaultContactId,
        paths,
        projectName,
        projectTypeId,
      }

      try {
        const res = await postSplitProject(newProject)
        const projectId = projectSummary.get('projectId')

        // split project success doesn't display this message,
        // rather it is passed to goToNewProjectSummary if the user
        // chooses to go to the newly created project
        dispatch(projectSummaryModalOpen('split-project'))
        dispatch(updateModalMessage(res.entity.projectId.toString()))

        // remove the paths from the UI
        dispatch(removeMultiplePaths(paths))

        // update this project's companies after the transaction
        dispatch(fetchAndSetProjectCompanies(projectId))
      } catch (err) {
        console.warn(err)
        throwSubmissionError(err)
      }
    })
  )
)

export default splitProject
